export default function OvalMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1796)">
                <rect width="100%" height="100%" fill="#FFC525" />
                <ellipse cx="500.001" cy="500" rx="392.753" ry="587.953" transform="rotate(-45 500.001 500)" fill="#01B4EE" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1796">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}